module.exports = function(fox) {
	//here we welcome static scope. This is static methods and variables container that is assigned both to constructor and prototype
	//i do not want to use standart for js constructor properties (which use a little less memory) because i want to can simply use static methods both from instance and 
	//constructor having some sugar from _ shorthand and having all data and logic consolidated in one simple declared object.

	var _ = {
		_helpers: {},

		registerHelper: function(name, obj) {
			_._helpers[name] = obj;
		},

		getBaseHelper: function() {
			return _._baseHelper;
		},

		_baseHelper: {
			_alias: '',
			_value: null,
			_message: '',
			_options: {},

			getAlias: function() {
				return this._alias;
			},

			setValue: function(value) {
				this._value = value;
				return this;
			}, 

			setMessage: function(msg) {
				this._message = msg;
				return this;
			},

			getMessage: function() {
				return this._message;
			},

			setOptions: function(options) {
				this._options = options;
				return this;
			}
		}
	};

	//private static. 
	var __getHelper = function(rule) {
		if (!fox.isSet(_._helpers[rule.validator])) {
			throw "No such validator";
		}

		var h = new _._helpers[rule.validator];
		return h.setMessage(rule.message || 'Value is invalid').setOptions(rule.options || {});
	};

	var __constructor = function () {
		this._ = _; 
		this._rules = {};
		this._validators = {};
		this._errorStack = {};
		this._state = false;
		this._fieldState = {};
		this._rulesChanged = true;
	};

	var Validator = fox.extend({

		setRules: function(rules) {
			fox.each(rules, function(ruleSet, field) {
				fox.each(ruleSet, function(rule){
					this.addRule(field, rule);
				}, this);
			}, this);

			return this;
		},

		addRule: function(field, rule) {
			this._rulesChanged = true;
			this._fieldState[field] = false;
			this._rules[field] = this._rules[field] || [];
			this._rules[field].push(rule);
			return this;
		},

		getInvalidFields: function() {
			var fields = [];

			fox.each(this._errorStack, function(desc, f) {
				fields.push(f);
			});

			return fields;
		},

		getErrors: function() {
			return this._errorStack;
		},

		isValid: function() {
			return this._state;
		},

		validate: function(field, value, option) {
			this._clearErrors(field)._compileRules();
			var fieldValid = true;

			if (fox.isSet(this._validators[field])) {
				fox.each(this._validators[field], function(v) {
					var result = v.setValue(value).validate(option);
					fieldValid = result && fieldValid;

					if (!result) {
						this._logError(field, v.getAlias(), value, v.getMessage());
					}
				}, this);
			}

			this._updateState(field, fieldValid);
			return fieldValid;
		},

		getFieldFirstMessage: function(field) {
			var
				fm;

			if (!this._fieldState[field] && this._errorStack[field] && this._errorStack[field][0]) {
				return this._errorStack[field][0]['message'];
			} else {
				fm = fox.toArray(this._errorStack).shift();

				return fm && fm.length && fm[0]['message'];
			}
		},

		getFieldMessages: function(field) {
			var messages = [];

			if (this._errorStack[field]) {
				fox.each(this._errorStack[field], function(error) {
					messages.push(error.message);
				}, this);
			}

			return messages;
		},

		_updateState: function(field, state) {
			this._fieldState[field] = state;
			this._state = true;

			fox.each(this._fieldState, function(fieldState) {
				this._state = fieldState && this._state;
			}, this);
		},

		_logError: function(field, validator, value, message) {
			this._errorStack[field] = this._errorStack[field] || [];
			this._errorStack[field].push({
				'validator': validator,
				'value': value,
				'message': message
			});
			return this;
		},

		_clearErrors: function(field) {
			field = field || null;

			if (!field) {
				this._errorStack = {};
				return this;
			}

			delete this._errorStack[field];

			return this;
		},

		_compileRules: function() {
			if (!this._rulesChanged) {
				return this;
			}

			this._validators = {};

			fox.each(this._rules, function(rules, field) {
				this._validators[field] = [];

				fox.each(rules, function(rule) {
					this._validators[field].push(__getHelper(rule));
				}, this);
			}, this);

			this._rulesChanged = false;

			return this;
		}

	}, null, __constructor, 'Validator');

	Validator._ = _;

	require('./validators/length')(fox, Validator);
	require('./validators/mandatory')(fox, Validator);
	require('./validators/postalcode')(fox, Validator);
	require('./validators/range')(fox, Validator);
	require('./validators/regexp')(fox, Validator);

	fox.Validator = Validator;
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/validator/validator.js
// module id = 232
// module chunks = 0